import { AxiosError } from "axios";
import BaseError from "es6-error";

class HttpError extends BaseError {
    status: number;
    headers: AxiosError["request"]["headers"];
    data: any;
    constructor(error: any) {
        super("An error occured during API call");
        const { status, data, headers } = error;

        this.status = status;
        this.headers = headers;
        this.data = data;
    }
}

export default HttpError;
